import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ClipboardService } from 'ngx-clipboard';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Code } from 'src/app/models/common';
import { User, UserChannel, OasisUser } from 'src/app/models/user';
import { CodeService } from 'src/app/services/code.service';
import { CommonService } from 'src/app/services/common.service';
import { OtpService } from 'src/app/services/otp.service';
import { UserService } from 'src/app/services/user.service';
import { SelectOasisIdDialogComponent } from '../../select-oasis-id-dialog/select-oasis-id-dialog.component';

@Component({
  selector: 'app-mobile-join',
  templateUrl: './mobile-join.component.html',
  styleUrls: ['./mobile-join.component.css']
})
export class MobileJoinComponent implements OnInit {

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private otpService: OtpService,
    private codeService: CodeService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private clipboardService: ClipboardService,
    private matDialog: MatDialog,
    private router: Router
  ) { 
    let user: User = this.commonService.getUserInfo()
    if(user) {
      this.router.navigate(['/'])
    }
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/join'])
    }
  }

  user: User = new User()
  corpCodePart1: string
  corpCodePart2: string
  corpCodePart3: string
  isAgree: boolean = false
  isAgree1: boolean = false
  isAgree2: boolean = false
  //userTypeList: Code[]
  ngOnInit(): void {
    //this.user.cashbillYn = 'N'
    let defaultChannel: UserChannel = new UserChannel()
    defaultChannel.channelType = ''
    this.user.userChannelList.push(defaultChannel)
    /*
    this.codeService.getUserTypeCodeList().subscribe(res => {
      this.userTypeList = res.data
    })
    */ 
    this.getBankCodeList()
  }
  bankCodeList: Code[]
  getBankCodeList() {
    this.codeService.getBankCodeList().subscribe(res => {
      this.bankCodeList = res.data
    })
  }
  bankCode: string = ''
  accountNumber: string
  depositor: string
  regidentNumberPart1: string
  regidentNumberPart2: string
  join() {
    if(!this.isUserIdCheck) {
      return alert('오아시스마켓 ID를 확인해 주세요')
    }
    if(!this.isPasswordCheck || !this.isConfirmPasswordCheck) {
      return alert('비밀번호를 확인해 주세요')
    }
    if(!this.user.userName) {
      return alert('이름을 입력해 주세요')
    }
    if(!this.isOtpConfirm) {
      return alert('핸드폰 인증을 진행해 주세요')
    }
    if(!this.user.email) {
      return alert('E-mail 주소를 입력해 주세요')
    }
    if(!this.depositor || this.depositor == '') {
      return alert("예금주명을 입력해 주세요")
     }
     if(this.bankCode == '') {
       return alert("은행을 선택해 주세요")
     }
     if(!this.accountNumber || this.accountNumber == '') {
       return alert("계좌번호를 입력해 주세요")
     }
    if(!this.accountFile) {
       return alert('통장사본을 첨부해 주세요')
    }
    if(this.recommendUserId && this.recommendUserId != '' && !this.isRecommendUserCheck) {
      return alert('추천인 정보 확인을 진행해 주세요\n추천인 정보가 존재하지 않으면 삭제해 주세요')
    }
    if(!this.user.userType) {
      return alert('사업자 유형을 선택해 주세요')
    }
    if((this.user.userType == 'UT2' || this.user.userType == 'UT3') && !this.licenseFile) {
      return alert('사업자 등록증을 첨부해 주세요')
    }
    this.user.depositor = this.depositor
    this.user.bankCode = this.bankCode
    this.user.accountNumber = this.accountNumber
    if((this.user.userType == 'UT2' || this.user.userType == 'UT3')) {
      this.user.corpCode = this.corpCodePart1 + '-' + this.corpCodePart2 + '-' + this.corpCodePart3
      const regex: RegExp = /^([0-9]{3})-([0-9]{2})-([0-9]{5})$/
      let corpCodeCheck: boolean = regex.test(this.user.corpCode)
      if(!corpCodeCheck) {
        return alert("사업자 번호가 올바르지 않습니다.\nex>123-12-12345");
      }
    }
    if((this.user.userType == 'UT1')) {
      if(this.regidentNumberPart1 || this.regidentNumberPart2) {
        let regidentNumber = this.regidentNumberPart1 + '-' + this.regidentNumberPart2
        const regex: RegExp = /^([0-9]{6})-([0-9]{7})$/
        let regidentNumberCheck: boolean = regex.test(regidentNumber)
        if(!regidentNumberCheck) {
          return alert("주민등록번호가 올바르지 않습니다.");
        }
        if(!this.licenseFile) {
          return alert('신분증 사본을 첨부해 주세요')
        }
        this.user.regidentNumber = this.regidentNumberPart1 + '-' + this.regidentNumberPart2
      }
    }
    let channelLength = this.user.userChannelList.filter(c => c.isOk).length
    if(channelLength == 0) {
      return alert('활동채널을 하나이상 등록해 주세요')
    }
    if(!this.isAgree) {
      return alert('가입내용에 동의해 주세요')
    }
    if(!this.isAgree1) {
      return alert('필수 약관에 동의해 주세요')
    }
    if(!this.isAgree2) {
      return alert('필수 약관에 동의해 주세요')
    }
    if((this.user.userType == 'UT2' || this.user.userType == 'UT3')) {
      this.user.cashbillYn = 'Y'
    } else {
      this.user.cashbillYn = 'N'
    }  
    const formData = new FormData();
    this.user.userChannelList = this.user.userChannelList.filter(c => c.isOk)
    formData.append('metaData', new Blob([JSON.stringify(this.user)], { type: "application/json" }))
    if(this.licenseFile) {
      formData.append("corpImageFile", this.licenseFile)
    }
    if(this.accountFile) {
      formData.append("paymentImageFile", this.accountFile)
    }
    this.spinner.show()
    this.userService.addUser(formData).subscribe(res => {
      this.spinner.hide()
      alert("정상적으로 회원가입이 완료 되었습니다.")
      this.router.navigateByUrl('/home')
    });
  }
  isUserIdCheck: boolean = false
  checkUserId() {
    if(this.user.userId == null || this.user.userId == '') {
      return alert('오아시스마켓 ID를 입력해 주세요')
    }
    this.userService.checkId(this.user.userId).subscribe(res => {
      if(res.resultCode == '8888') {
        alert(res.message)
      } else {
        this.user.oasisUserNo = res.data
        this.toastr.success("사용 가능한 아이디입니다")
        this.isUserIdCheck = true
      }
    })
  }
  isPasswordCheck: boolean = false
  passwdCheckMsg: string
  checkPassword() {
    if(this.user.password) {
      let regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@\#$%<>^&*+-])[A-Za-z\d~!@\#$%<>^&*+-]{8,}$/
      if(!regex.test(this.user.password)) {
        this.passwdCheckMsg = "비밀번호는 영문,숫자,특수문자(~!@\#$%<>^&*+-)조합으로 8자이상만 가능합니다"
      } else {
        this.isPasswordCheck = true
        this.passwdCheckMsg = null
      }
    } else {
      this.passwdCheckMsg = null
    }
    this.checkConfirmPassword()
  }
  confirmPasswdCheckMsg: string
  isConfirmPasswordCheck: boolean = false
  checkConfirmPassword() {
    if(!this.user.password && !this.user.passwordConfirm) {
      this.confirmPasswdCheckMsg = null
    } else {
      if(this.user.password != this.user.passwordConfirm) {
        this.confirmPasswdCheckMsg = "비밀번호가 일치하지 않습니다"
        this.isConfirmPasswordCheck = false
      } else {
        this.confirmPasswdCheckMsg = null
        this.isConfirmPasswordCheck = true
      }
    }
  }
  isOtpSend: boolean = false
  signUpOtpSend() {
    if(!this.user.tel) {
      return alert("핸드폰 번호를 입력해 주세요")
    }
    this.user.tel = this.user.tel.replace(/-/gi, "")
    if(!(this.user.tel.startsWith('010') && this.user.tel.length == 11)) {
      return alert("핸드폰 번호를 확인해 주세요")
    }
    this.otpService.signUpOtpSend(this.user.tel).subscribe(res => {
      this.isOtpSend = true
      this.user.otpCode = null
      this.timer()
    })
  }
  isOtpConfirmTry: boolean = false
  isOtpConfirm: boolean = false
  signUpOtpCheck() {
    if(!this.user.otpCode) {
      return alert("인증번호를 입력해 주세요")
    }
    this.isOtpConfirmTry = true
    this.otpService.signUpOtpCheck(this.user.tel, this.user.otpCode, this.intervalCheckTime).subscribe(res => {
      this.isOtpConfirm = res.data
      this.displayTime = ''
      clearInterval(this.timerInterval)
      if(this.isOtpConfirm) {
        this.toastr.success("인증이 완료되었습니다")
        if(!this.isUserIdCheck) {
          this.userService.findOasisIdByTel(this.user.tel, this.user.otpCode).subscribe(res1 => {
            let oasisIdList: OasisUser[] = res1.data
            this.openSelectOasisIdPopup(oasisIdList)
          })
        }
      } else {
        alert("인증번호가 일치하지 않습니다")
        this.isOtpConfirmTry = false
        this.isOtpSend = false
        this.user.otpCode = null
        this.user.tel = null
      }
    })
  }
  intervalCheckTime: number = 5
  displayTime: string
  timerInterval: any
  timer() {
    let minute = this.intervalCheckTime
    let seconds: number = minute * 60
    let textSec: any = "0"
    let statSec: number = 60
    const prefix = minute < 10 ? "0" : "";
    this.timerInterval = setInterval(() => {
      seconds--
      if (statSec != 0) {
        statSec-- 
      } else {
        statSec = 59
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      } 
      this.displayTime =  prefix + (Math.floor(seconds / 60)) + ':' + textSec
      if (seconds == 0) {
        clearInterval(this.timerInterval)
        this.isOtpSend = false
      }
    }, 1000)
  }
  recommendUserId: string
  licenseFile: File    // 사업자등록증
  licenseFileName: string
  //thumbImgSrc = '';    // 프리뷰
  onFileChange(files: FileList, event: any) {
    if (files && files.length > 0) {
      this.licenseFile = files[0]
      this.licenseFileName = this.licenseFile.name
      //console.log(this.licenseFile.size)
    }
  }
  accountFile: File    // 통장사본
  accountFileName: string
  onFileChange1(files: FileList, event: any) {
    if (files && files.length > 0) {
      this.accountFile = files[0]
      this.accountFileName = this.accountFile.name
      //console.log(this.licenseFile.size)
    }
  }

  //활동채널
  addChannel(item: UserChannel) {
    if(!item.channelType || item.channelType == '') {
      return alert('채널을 유형을 선택해 주세요') 
    }
    if(!item.channelUrl || !item.channelUrl.startsWith('http')) {
      return alert('URL을 정확하게 입력해 주세요') 
    }
    item.isOk = true
    let defaultChannel: UserChannel = new UserChannel()
    defaultChannel.channelType = ''
    this.user.userChannelList.push(defaultChannel)
  }
  removeChannel(item: UserChannel) {
    let index = this.user.userChannelList.indexOf(item)
    this.user.userChannelList.splice(index, 1)
  }

  openSelectOasisIdPopup(oasisIdList: OasisUser[]) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = false
    dialogConfig.id = "openSelectOasisIdPopup"
    dialogConfig.data = { 
        oasisIdList: oasisIdList
      , parentRef: this
    }
    const matDialog = this.matDialog.open(SelectOasisIdDialogComponent, dialogConfig);
    matDialog.afterClosed().subscribe(res => {
      //none
    })
  }
  selectUserId(userId: string, oasisUserNo: number) {
    this.user.userId = userId
    this.user.oasisUserNo = oasisUserNo
    this.toastr.success(userId + "를 선택하셨습니다.")
    this.isUserIdCheck = true
  }
  isRecommendUserCheck: boolean = false
  getRecommendUserNo() {
    if(!this.recommendUserId || this.recommendUserId == '') {
      return alert('추천인의 아이디를 입력해 주세요')
    }
    this.userService.getRecommendUserNo(this.recommendUserId).subscribe(res => {
      if(res.resultCode == '8888') {
        alert(res.message)
        this.recommendUserId = null
      } else {
        this.user.recommendUserNo = res.data
        this.toastr.success("추천인 정보가 확인되었습니다.")
        this.isRecommendUserCheck = true
      }
    })
  }

}
